<template>
  <a-drawer v-model:visible="drawer" :title="title" placement="right" :maskClosable="!uploading" :closable="!uploading"
    @close="() => drawer = false" width="70%">
    <a-row :gutter="16" class="mb-2">
      <a-col :span="8">
        <a-form-item label="收款平台" v-if="type === 'trade'">
          <a-select v-model:value="platform" :options="platforms" :filter-option="$filters.filterOption"
            placeholder="请选择" show-search />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <div class="d-flex justify-center align-center mb-2">
          <a-upload-dragger :before-upload="beforeUpload" :disabled="uploading || (type === 'trade' && !platform)"
            :showUploadList="false" multiple accept=".xls,.xlsx">
            <p class="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p class="ant-upload-text">选择或拖拽文件上传</p>
            <p class="ant-upload-hint">
              支持单个或多个文件，请注意文件格式要求，单个文件大小不能超过2MB。
            </p>
          </a-upload-dragger>
        </div>
      </a-col>
      <a-col :span="8" v-if="template_files.length > 0">
        <a-space direction="vertical">
          <a v-for="(item, index) in template_files" :key="index" :href="`${publicPath}template/${item}`"
            target="_blank">
            <DownloadOutlined />
            {{ item }}
          </a>
        </a-space>
      </a-col>
    </a-row>
    <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
      :pagination="{
        current: page,
        pageSize: limit,
        total: count,
        showQuickJumper: true,
        showSizeChanger: true,
      }" @change="(pagination) => {
        page = pagination.current;
        limit = pagination.pageSize;
      }">
      <template #title>
        <a-button type="primary" :loading="dataLoading" @click="getData">刷新</a-button>
      </template>
      <template #bodyCell="{ record, column, index }">
        <template v-if="column.dataIndex === 'index'">
          {{ index + 1 }}
        </template>
        <template v-if="column.dataIndex === 'platform'">
          {{ getplatform(record.platform) }}
        </template>
        <template v-if="column.dataIndex === 'file'">
          <a href="javascript:;" @click="downloadfile(record)">{{ record.originalname }}</a>
        </template>
        <template v-if="column.dataIndex === 'state'">
          <a-tag v-if="record.state === 0" color="processing">正在处理</a-tag>
          <template v-if="record.state === 1">
            <a-tag v-if="record.result?.fail > 0" color="error">异常</a-tag>
            <a-tag v-else color="success">成功</a-tag>
          </template>
          <a-tag v-if="record.state === -1" color="error">失败</a-tag>
        </template>
        <template v-if="column.dataIndex === 'result'">
          <template v-if="record.state === 1">
            <a-tooltip title="总数" color="blue">
              <a href="javascript:;" class="text-info">{{ record.result?.count }}</a>
            </a-tooltip>
            /
            <a-tooltip title="成功" color="green">
              <a href="javascript:;" class="text-success">{{ record.result?.success }}</a>
            </a-tooltip>
            /
            <a-tooltip title="异常" color="red">
              <a href="javascript:;" class="text-error" @click="showErrors(record)">{{ record.result?.fail }}</a>
            </a-tooltip>
          </template>
          <template v-if="record.state === -1">
            <span class="text-error"> {{ record.result }} </span>
          </template>
        </template>
        <template v-if="column.dataIndex === 'operation'">
          <a-space>
            <a href="javascript:;" @click="downloadfile(record)">下载</a>
            <a-popconfirm title="确定要删除?" @confirm="remove(record._id)">
              <a href="javascript:;" class="text-error">删除</a>
            </a-popconfirm>
            <a v-if="record.state === -1 || (record.result && record.result.fail > 0)" href="javascript:;"
              class="text-error" @click="reset(record._id)">重试</a>
          </a-space>
        </template>
      </template>
    </a-table>
    <a-modal v-model:visible="modal" title="上传失败结果" :footer="null">
      <a-list size="small" bordered :data-source="errors" :pagination="{
        pageSize: 20,
        hideOnSinglePage: true,
        showSizeChanger: false,
      }">
        <template #renderItem="{ item }">
          <a-list-item>{{ item }}</a-list-item>
        </template>
      </a-list>
    </a-modal>
  </a-drawer>
</template>
<script setup>
import { InboxOutlined, DownloadOutlined } from "@ant-design/icons-vue";
import { ref, watch, computed, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
import Async from "async";
import { message } from "ant-design-vue";
const { proxy } = getCurrentInstance();
const publicPath = ref(process.env.BASE_URL);
const title = ref('');
const type = ref('');
const platforms = ref([]);
const platform = ref(null);
const template_files = ref([]);
const drawer = ref(false);
const uploading = ref(false);
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(10);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const modal = ref(false);
const errors = ref([]);
const width = computed(() => proxy.$utils.twidth(columns));
const columns = computed(() => {
  return [
    { title: '序号', dataIndex: 'index', width: 80 },
    ...(type.value === 'trade' ? [{ title: '收款平台', dataIndex: 'platform', width: 120 },] : []),
    { title: '文件', dataIndex: 'file', width: 150, },
    { title: '状态', dataIndex: 'state', width: 100, },
    { title: '结果', dataIndex: 'result', width: 150, },
    { title: '时间', dataIndex: 'create_time', width: 120, },
    { title: '操作', dataIndex: 'operation', width: 120, },
  ];
})
onActivated(() => {
  getData();
});
watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});
const showUpload = ({ title: v1, type: v2, platforms: v3 }) => {
  title.value = v1;
  type.value = v2;
  switch (v2) {
    case 'order': //订单
      template_files.value = [`订单导入模板.xlsx`];
      break;
    case 'purchase': //采购单
      template_files.value = [`采购单导入模板.xlsx`];
      break;
    case 'inventory': //库存SKU
      template_files.value = [`库存SKU导入模板.xlsx`];
      break;
    case 'trade': //收款明细
      // template_files.value = [`艾贝盈导入模板.xlsx`, `连连导入模板.xlsx`];
      template_files.value = [];
      platforms.value = v3;
      platform.value = null;
      break;
  }
  drawer.value = true;
  getData();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/uploadtask/list", { page: page.value, limit: limit.value, type: type.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const reset = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/uploadtask/reset", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const remove = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/uploadtask/remove", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const showErrors = (item) => {
  if (item.result.fail > 0) {
    errors.value = item.result.errors;
    modal.value = true;
  }
}
const beforeUpload = (file, fileList) => {
  console.log('beforeUpload', file, fileList);
  let checkresult = checkfile(file);
  if (checkresult.code !== 0) {
    message.error(checkresult.msg);
    return false;
  }
  return doUpload(file);
};
const checkfile = (file) => {
  const valid_type = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel";
  const valid_size = file.size / 1024 / 1024 <= 2;
  if (!valid_type) {
    return { code: 1, msg: `${file.name}文件上传失败：只允许上传xls,xlsx文件` };
  }
  else if (!valid_size) {
    return { code: 1, msg: `${file.name}文件上传失败：单个文件不能超过2MB` };
  }
  return { code: 0 };
}
const doUpload = (file) => {
  const slicefiles = proxy.$utils.sliceFile(file.size);
  const faid = proxy.$utils.uuid();
  uploading.value = true;
  return new Promise((resolve, reject) => {
    Async.eachSeries(slicefiles, (slicefile, callback) => {
      const formData = new FormData();
      if (slicefile.chunks > 1) {
        let _file = file.slice(slicefile.from, slicefile.to);
        formData.set("file", _file);
      } else {
        formData.set("file", file);
      }
      formData.set("faid", faid);
      formData.set("chunk", slicefile.chunk);
      formData.set("chunks", slicefile.chunks);
      formData.set("originalname", file.name);
      formData.set("type", type.value);
      if (platform.value) formData.set("platform", platform.value);
      proxy.$api.doUpload("/uploadtask/plupload", formData).then((res) => {
        if (res.code === 0) {
          if (slicefile.chunk + 1 === slicefile.chunks) {
            getData();
          }
          callback(null);
        } else {
          message.error(res.msg);
          callback(res.msg);
        }
      }).catch((err) => {
        console.error(err);
        callback(err);
      });
    }, (error) => {
      if (error) reject(error);
      else resolve();
      uploading.value = false;
    });
  });
}
const downloadfile = (record) => {
  if (record.remoteurl) {
    proxy.$utils.download(record.remoteurl, record.originalname);
  }
}
const getplatform = (platform) => {
  return _.findWhere(platforms.value, { value: platform })?.label;
}
defineExpose({
  showUpload
});
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}
</style>